import convertLocaleStringToNumber from './convertLocaleStringToNumber';
export default function getNumberDisplay(value) {
  return convertLocaleStringToNumber(value).toLocaleString();
}